{
    "HeaderSidebar_ExpandMenu": "Espandi menu (Ctrl + ])",
    "HeaderSidebar_CollapseMenu": "Comprimi menu (Ctrl + [)",
    "HeaderSidebar_PinMenu": "Menu Pin espanso",
    "HeaderSidebar_UnpinMenu": "Sblocca il menu",
    "NAME": "HeaderSidebar"
}